module.exports = __webpack_public_path__ + "d5b2c83fc55c34360934881a85a7aca7.svg";